/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_qD_113_68 as Componente_qD_113_68,
  rec_Componente_uk_117_107 as Componente_uk_117_107,
  rec_JSXRuntime as JSXRuntime,
  rec_Ki as Ki,
  rec_Mr as Mr,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Sn as Sn,
  rec_pk as pk,
  rec_tk as tk,
  rec_wi as wi,
} from "../../runtime/index.jsx";
export function Componente_ek_101_107(e) {
  let t = (0, ReactCompiler.c)(15),
    { hijos: n, totales: r, administrando: i, onEditar: a, onEliminar: o } = e,
    s;
  t[0] === r
    ? (s = t[1])
    : ((s = new Map((r ?? []).map(tk))), (t[0] = r), (t[1] = s));
  let c = s,
    l;
  if (t[2] !== i || t[3] !== n || t[4] !== a || t[5] !== o || t[6] !== c) {
    let e;
    (t[8] !== i || t[9] !== a || t[10] !== o || t[11] !== c
      ? ((e = (e) => {
          let t = c.get(String(e.id)),
            n = t && (t.totalProyectos > 0 || t.totalTareas > 0);
          return (
            <li
              key={e.id}
              className={`group relative`}
              children={[
                <Sn
                  to={`/organizacion/${e.id}`}
                  className={`flex flex-wrap items-center gap-x-3 gap-y-1 rounded-xl border border-(--border) px-3 py-2 pr-16 text-sm transition hover:bg-(--accent-bg)`}
                  children={[
                    <span
                      className={`min-w-0 flex-1 truncate font-medium text-(--text-h)`}
                      children={e.nombre}
                    />,
                    <Componente_qD_113_68
                      sedeId={e.sedeId}
                      nombre={e.sedeNombre}
                    />,
                    <span
                      className={`truncate text-xs text-(--text)`}
                      children={pk(e)}
                    />,
                    n ? (
                      <JSXRuntime.Fragment
                        children={[
                          <span
                            className={`shrink-0 text-xs text-(--text)`}
                            children={[
                              t.totalProyectos === 1
                                ? `1 proyecto`
                                : `${t.totalProyectos} proyectos`,
                              t.totalTareas > 0 &&
                                ` · ${t.completadas} de ${t.totalTareas} terminadas`,
                            ]}
                          />,
                          <Componente_uk_117_107 valor={t.avancePromedio} />,
                        ]}
                      />
                    ) : (
                      <span
                        className={`shrink-0 text-xs text-(--text)`}
                        children={`sin tareas todavía`}
                      />
                    ),
                  ]}
                />,
                <div
                  className={`pointer-events-none absolute right-3 top-1/2 flex -translate-y-1/2 items-center gap-1`}
                  children={[
                    i && (
                      <div
                        className={`pointer-events-auto flex gap-1`}
                        children={[
                          <button
                            type={`button`}
                            onClick={() => a(e)}
                            aria-label={`Editar ${e.nombre}`}
                            className={`rounded-lg p-2 text-(--text) hover:bg-(--accent-bg) hover:text-(--accent) transition duration-150 ease-(--curva) active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--accent-border) focus-visible:ring-offset-1 focus-visible:ring-offset-(--bg) disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100`}
                            children={(0, JSXRuntime.jsx)(wi, {
                              className: `h-3.5 w-3.5`,
                            })}
                          />,
                          <button
                            type={`button`}
                            onClick={() => o(e)}
                            aria-label={`Eliminar ${e.nombre}`}
                            className={`rounded-lg p-2 text-(--text) hover:bg-(--error-bg) hover:text-(--error) transition duration-150 ease-(--curva) active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--accent-border) focus-visible:ring-offset-1 focus-visible:ring-offset-(--bg) disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100`}
                            children={<Ki className={`h-3.5 w-3.5`} />}
                          />,
                        ]}
                      />
                    ),
                    <Mr className={`h-4 w-4 text-(--text)`} />,
                  ]}
                />,
              ]}
            />
          );
        }),
        (t[8] = i),
        (t[9] = a),
        (t[10] = o),
        (t[11] = c),
        (t[12] = e))
      : (e = t[12]),
      (l = n.map(e)),
      (t[2] = i),
      (t[3] = n),
      (t[4] = a),
      (t[5] = o),
      (t[6] = c),
      (t[7] = l));
  } else l = t[7];
  let u;
  return (
    t[13] === l
      ? (u = t[14])
      : ((u = (
          <ul className={`animar-cascada flex flex-col gap-1`} children={l} />
        )),
        (t[13] = l),
        (t[14] = u)),
    u
  );
}
